/* src/app/modules/shared/components/column/column-tiny-spacer/column-tiny-spacer.component.scss */
app-column-tiny-spacer {
  display: contents;
}
/*# sourceMappingURL=column-tiny-spacer.component.css.map */
